import { get } from 'lodash';
import Vue from 'vue';

const guides = {
  empty: {
    name: '',
    steps: [],
    currentStep: null,
  },
};

export default {
  namespaced: true,
  state: { ...guides.empty },

  actions: {
    initializeGuide(context, { guide }) {
      context.commit('SET_GUIDE', { guide });
    },

    restartGuide(context) {
      context.commit('SET_STEP', { step: 0 });
    },

    incrementStep(context) {
      const { currentStep, steps } = context.state;
      const newIndex = currentStep + 1;
      if (newIndex > steps.length + 1) {
        this.dismissGuide();
      } else {
        const step = newIndex;
        context.commit('SET_STEP', { step });
      }
    },

    dismissGuide(context) {
      context.commit('SET_GUIDE', { guide: guides.empty });
    },
  },

  getters: {
    currentStepName(state) {
      const currentStep = state.steps[state.currentStep];
      return currentStep && currentStep.name;
    },

    guideText(state) {
      return (name) => {
        const stepInfo = state.steps.find((step) => step.name === name);
        return stepInfo.text;
      };
    },

    showReset(state) {
      return (name) => {
        const stepInfo = state.steps.find((step) => step.name === name);
        return get(stepInfo, 'showReset', true);
      };
    },
    showNext(state) {
      return (name) => {
        const stepInfo = state.steps.find((step) => step.name === name);
        return get(stepInfo, 'showNext', true);
      };
    },
  },

  mutations: {
    SET_STEP(state, { step }) {
      Vue.set(state, 'currentStep', step);
    },

    SET_GUIDE(state, { guide }) {
      Vue.set(state, 'steps', guide.steps);
      Vue.set(state, 'currentStep', guide.currentStep);
      Vue.set(state, 'guideName', guide.name);
    },

  },
};
